import { useState } from "react";
import { useAppDispatch } from "../../../../../app/hooks";
import { CustomButton } from "../../../../../common/components/functional/customButton/CustomButton";
import { getWorkAgreementDocumentDownloadUrls } from "../../../../orders/orderRowsDetailedSlice";
import { isFulfilled } from "@reduxjs/toolkit";
import { decodeWorkAgreementDocumentDownloadUrls } from "../../../../orders/editOrder/long/workAgreement/helpers";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import { downloadBlob } from "../../../../../common/helpers/downloadBlob";

type Props = {
  workAgreementDocumentId: string;
};

export const ExportWorkAgreementDocument = ({
  workAgreementDocumentId,
}: Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("workAgreementDocument");

  const [isLoading, setIsLoading] = useState(false);

  const downloadWorkAgreement = async () => {
    if (!workAgreementDocumentId || isLoading) return;
    setIsLoading(true);
    try {
      const action = await dispatch(
        getWorkAgreementDocumentDownloadUrls({
          workAgreementDocumentId,
        }),
      );
      if (!isFulfilled(action)) return;
      const urls = decodeWorkAgreementDocumentDownloadUrls(action.payload);
      // TODO merge files into one pdf?
      const files = [
        ...(urls.mainDocument ? [urls.mainDocument] : []),
        ...urls.attachments,
      ];
      for (const file of files) {
        const response = await fetch(file.url);
        if (!response.ok) continue;
        downloadBlob(await response.blob(), file.filename);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CustomButton
      variant="outlined"
      onClick={downloadWorkAgreement}
      sx={{ borderRadius: "24px" }}
      disabled={isLoading}
    >
      {!isLoading ? (
        t("workAgreementDocument:downloadWorkAgreement")
      ) : (
        <CircularProgress size={16} sx={{ marginTop: "2px" }} />
      )}
    </CustomButton>
  );
};
